module.exports = __webpack_public_path__ + "static/media/crdscia.624e9569.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/public/userarea/crdscia.png
// module id = 80
// module chunks = 0